import React from 'react';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { getVideoPages, queryAllVideoGroups, queryAllVideoLessons, request as typedRequest } from 'lib/dato-request';
import { Layout } from 'components/Layout';
import VideoCard from './components/VideoCard';

export const VideoGrid = ({ videos }) => {
    return (
        <div className='mx-auto max-w-[1305px]'>
            <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 px-8 pt-16 '>
                {videos.map((video, index) => (
                    <div>
                        <VideoCard video={video} />
                    </div>
                ))}
            </div>
        </div>
    );
};

const SeoNav = ({ data }) => {
    const { videoPage, videos } = data;
    const { seo, groups } = videoPage;

    return (
        // <Layout showClassCodeInput={false} showLoginAndSignup={true} videoGroups={groups}>
        <Layout showClassCodeInput={false} showLoginAndSignup={true}>
            <div>
                <NextSeo title={seo?.title ?? videoPage.heading ?? videoPage.slug} description={seo?.description} />
                <Head>
                    <meta name='keywords' content={videoPage.keywords} />
                </Head>
            </div>
        </Layout>
    );
};

export async function getStaticProps({ params }) {
    const query = await queryAllVideoLessons();
    const videos = query.allVideoLessons;
    console.log('videos', videos);

    const query2 = await queryAllVideoGroups();
    const groups = query2.allVideoGroups;
    console.log('video groups', groups);

    const data = {
        videoPage: {
            seo: {},
            groups,
            components: []
        },
        videos
    };
    // const { slug } = params;
    // const data = await typedRequest(VideoPageDocument, { slug });
    return { props: { data } };
}

export default SeoNav;
